import {
  TEN_MIN_INTERVAL,
  timeIntervalList,
  FIVE_MIN_INTERVAL,
  THIRTY_MIN_INTERVAL,
  HOUR_INTERVAL,
  DAY_INTERVAL,
  activityBoxHeight,
  activityIntervalDistance,
  activityBoxStartHeight,
  ACTIVITY_BOX_GUARANTEED_VISIBILITY_HEIGHT,
  sessionBoxStartHeight,
} from "@/app/activity/components/timeline/activityTimeline/constants"
import {
  RangeKey,
  Tick,
  ActivityDataProps,
  TimelineItemBoxProps,
} from "@/app/activity/components/timeline/activityTimeline/type"
import { Activity } from "@/types/activity"
import { ActivityDurationData } from "@/types/data"
import { Session } from "@/types/session"
// import { ActivityData } from "@/types/activity"
// import { PlayerDevice } from "@/types/device"
import { isDate } from "@/utils/typeOf"
import { scaleTime } from "d3-scale"
import { BaseType, select, Selection } from "d3-selection"
// import { scaleTime, scaleLinear } from "d3-scale"
// import { BaseType, select } from "d3-selection"
import { timeFormat } from "d3-time-format"
import { Duration, format, sub, add } from "date-fns"
import moment from "moment"
// import { isNil } from "lodash"

const hourMinFormat = "%H:%M"
const monthDayFormat = "%m.%d"

// type TransformedActivityDataType = Omit<ActivityData, "dateStart" | "dateFinish"> & {
//   serial: string
//   dateStart: Date
//   dateFinish: Date
//   isGps: boolean
//   isImu: boolean
//   isHr: boolean
//   devicePlayer?: {
//     backNumber: number
//     nickName: string
//     serialNumber: string
//   }
// }

// type TransformedActivityDataKey = keyof TransformedActivityDataType

// export type TransformedActivityData = {
//   [key in TransformedActivityDataKey]: TransformedActivityDataType[key]
// }
export function getTimeInterval(overallTimestamp: number) {
  const numTick = 12
  let timeInterval = TEN_MIN_INTERVAL

  for (const i in timeIntervalList) {
    timeInterval = timeIntervalList[i]
    const quotient = Math.floor(overallTimestamp / timeInterval)
    if (quotient <= numTick) {
      break
    }
  }

  return timeInterval
}

function getTimeFormat(timeInterval?: number) {
  switch (timeInterval) {
    case FIVE_MIN_INTERVAL:
    case TEN_MIN_INTERVAL:
    case THIRTY_MIN_INTERVAL:
    case HOUR_INTERVAL:
      return { timeFormat: hourMinFormat, boldTimeFormat: monthDayFormat }
    case DAY_INTERVAL:
      return { timeFormat: monthDayFormat, boldTimeFormat: "" }
    default:
      return {
        timeFormat: hourMinFormat,
        boldTimeFormat: monthDayFormat,
      }
  }
}

function customTimeFormat(date: Date, format: string) {
  const formatDate = timeFormat(format ? format : hourMinFormat)

  return formatDate(date)
}

// export function formatISOString(time: string) {
//   const formatTime = format(new Date(time), "yyyy/MM/dd HH:m:s")

//   return new Date(formatTime).toISOString()
// }

// export function getTimePerWidth(chartWidth: number, start: Date, end: Date) {
//   return chartWidth ? (end.getTime() - start.getTime()) / chartWidth : 0
// }
// export function getWidthPerTime(chartWidth: number, start: Date, end: Date) {
//   const timeDiff = end.getTime() - start.getTime()

//   return timeDiff ? chartWidth / timeDiff : 0
// }

export function getXPositionByDate(date: Date | number, start: Date | number, end: Date | number) {
  if (isDate(date)) {
    const xScale = scaleTime().domain([start, end])

    return xScale(date)
  }
  const xScale = scaleTime().domain([start, end])

  return xScale(date)
}

// export function getDateByXScale(chartWidth: number, start: number, end: number) {
//   return scaleLinear()
//     .domain([0, chartWidth]) // end 기준
//     .range([start, end])
// }

// export function getdateFinishBydateStart(dateStart: Date, more: Duration) {
//   return add(dateStart, more)
// }

export function getdateStartBydateFinish(dateFinish: Date, more: Duration) {
  return sub(dateFinish, more)
}

export function getMoredateStartBydateStart(dateStart: Date, more: Duration) {
  return sub(dateStart, more)
}

export function getMoredateFinishBydateFinish(dateFinish: Date, more: Duration) {
  return add(dateFinish, more)
}

export function getMoreRangeScope(key: RangeKey): Duration {
  switch (key) {
    case RangeKey._24h:
      return { hours: 24 }
    case RangeKey.ACTIVITY:
      return { hours: 0 }
    case RangeKey.CROP:
      return { hours: 1 }
    default:
      return { hours: 24 }
  }
}

export const rangeObject: { [key in RangeKey]: Tick } = {
  [RangeKey.ACTIVITY]: {
    show: false,
    key: RangeKey.ACTIVITY,
    label: "",
    unit: "minutes",
    timeInterval: TEN_MIN_INTERVAL,
    add: { hours: 2 },
  },
  [RangeKey._24h]: {
    key: RangeKey._24h,
    show: true,
    label: 24,
    unit: "hours",
    timeInterval: HOUR_INTERVAL,
    add: { hours: 24 },
  },

  [RangeKey.CROP]: {
    show: false,
    key: RangeKey.CROP,
    label: "",
    unit: "minutes",
    timeInterval: FIVE_MIN_INTERVAL,
    add: { hours: 1 },
  },
}

export const ranges = Object.values(rangeObject)

export function createTicks(
  timeLineWidth: number,
  RangeKey: RangeKey,
  dateFinish?: Date,
  dateStart?: Date,
) {
  if (!dateFinish || !dateStart) {
    return []
  }

  // end
  // timeLineWidth
  const chartWidth = timeLineWidth
  const rangesItem = ranges.find((range) => range.key === RangeKey)

  const more = getMoreRangeScope(RangeKey)

  let start = getdateStartBydateFinish(dateFinish, more)
  if (dateStart) {
    start = dateStart
  }

  const moreStart = getMoredateStartBydateStart(start, more)
  const moreEnd = getMoredateFinishBydateFinish(dateFinish, more)
  const chartTimeStamp = dateFinish.getTime() - start.getTime()
  const overallTimestamp = moreEnd.getTime() - moreStart.getTime()

  const timeInterval = getTimeInterval(chartTimeStamp)
  const tickLength = Math.floor(overallTimestamp / (timeInterval || 1)) + 1

  const { timeFormat, boldTimeFormat } = getTimeFormat(rangesItem?.timeInterval)
  return Array.from({ length: tickLength }, () => null).map((_, index) => {
    const tickTimestamp = moreStart.getTime() + index * timeInterval

    const date = new Date(tickTimestamp)

    if (timeFormat === monthDayFormat) {
      date.setHours(0, 0, 0)
    }

    const x = getXPositionByDate(date, start, dateFinish) * chartWidth
    const text = format(date, "HH:mm")

    const isMidnight = date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0
    const boldText = boldTimeFormat && isMidnight ? customTimeFormat(date, boldTimeFormat) : ""

    return {
      date,
      x,
      text,
      boldText,
      isMidnight,
    } as Tick
  })
}

// export function createTextDot(
//   nodeList: Selection<BaseType, unknown, Element, unknown>,
//   nodeWidth: number,
//   textValue = "",
// ) {
//   nodeList.each(function () {
//     const text = select(this)
//     const words = textValue.split(/\s+/) || text.text().split(/\s+/)

//     const ellipsis = text.text("").append("tspan").attr("class", "elip").text("...")
//     const width = parseFloat(
//       (nodeWidth - 10 - (ellipsis?.node?.()?.getComputedTextLength() || 0)).toString(),
//     )
//     const numWords = words.join(" ")

//     const tspan = text.insert("tspan", ":first-child").text(words.join(" "))

//     let remainWords = words.slice().join(" ")
//     while ((tspan.node()?.getComputedTextLength() || 0) > width && remainWords.length) {
//       remainWords = remainWords.slice(0, -1)
//       tspan.text(remainWords)
//     }

//     if (remainWords.length === numWords.length) {
//       ellipsis.remove()
//     }
//   })
// }

// export function sortPlayers(a: PlayerDevice, b: PlayerDevice) {
//   if (a.deviceNumber && !b.deviceNumber) {
//     return -1
//   } else if (!a.deviceNumber && b.deviceNumber) {
//     return 1
//   }

//   return a.backNumber ? a.backNumber - b.backNumber : 1
// }

// export const transformData = (data: ActivityData): TransformedActivityDataType => {
//   const {
//     deviceModel,
//     deviceNumber,
//     deviceVersion,
//     existGps,
//     existImu,
//     existHr,
//     dateStart,
//     dateFinish,
//   } = data
//   const serial = generateSerial(deviceModel, deviceVersion, deviceNumber)

//   return {
//     ...data,
//     serial,
//     dateStart: new Date(dateStart),
//     dateFinish: new Date(dateFinish),
//     isGps: existGps,
//     isImu: existImu,
//     isHr: existHr,
//   }
// }

// /**
//  *
//  * @param sessionCropRange 유저가 클릭으로 생성한 포지션 정보
//  * @param sessionCropRangesFromProps 유저가 생성한 세션 정보 aka 백엔드 데이터
//  * @param timelineWidth 타임라인 너비
//  * @param mouse 마우스 좌표
//  * @returns [number, number] 설정 가능한 범위
//  */
// export function getMaximumSessionCropValidRange({
//   sessionCropRange,
//   sessionCropRangesFromProps,
//   timelineWidth,
//   mouse,
// }: {
//   sessionCropRange: Array<number | undefined>
//   sessionCropRangesFromProps: number[][]
//   timelineWidth: number
//   mouse: number[]
// }) {
//   const [start] = sessionCropRange
//   const [x] = mouse
//   let availableRanges = [[0, timelineWidth]]

//   if (isNil(x)) {
//     return availableRanges[0]
//   }

//   if (!start || sessionCropRangesFromProps.length === 0) {
//     return [0, mouse[0]]
//   }

//   const sorted = sessionCropRangesFromProps.sort((a, b) => a[0] - b[0])
//   // 설정 가능한 범위를 초기화

//   // 각 설정 불가능한 범위를 통해 설정 가능한 범위를 갱신
//   sorted.forEach(([start, end]) => {
//     const updatedRanges: number[][] = []

//     availableRanges.forEach(([availStart, availEnd]) => {
//       // 설정 불가능한 범위의 시작이 현재 범위 안에 있을 때
//       if (start > availStart && start < availEnd) {
//         updatedRanges.push([availStart, start])
//       }
//       // 설정 불가능한 범위의 끝이 현재 범위 안에 있을 때
//       if (end > availStart && end < availEnd) {
//         updatedRanges.push([end, availEnd])
//       }
//       // 설정 불가능한 범위가 현재 범위를 포함하지 않을 때만 그대로 유지
//       if (start >= availEnd || end <= availStart) {
//         updatedRanges.push([availStart, availEnd])
//       }
//     })

//     availableRanges = updatedRanges
//   })

//   const [startCropX] = sessionCropRange

//   // 커서 좌표가 포함된 단일 범위를 찾음
//   let range = availableRanges.find(
//     ([start, end]) =>
//       x >= start && x <= end && (startCropX || x) >= start && (startCropX || x) <= end,
//   )
//   if (!range && !isNil(startCropX)) {
//     // 가장 가까운 범위를 찾기 위해 유저가 ㅋ클릭으로 설정한 시작점을 기준으로 찾음
//     range = availableRanges.find(([start, end]) => startCropX >= start && startCropX <= end)
//     // 가장 마지막 설정 가능한 범위 이후에 있는 경우 마지막 범위 반환
//     if (!range) {
//       range = availableRanges[availableRanges.length - 1]
//     }
//   }

//   return range
// }

export const getPositionX = ({
  start,
  end,
  width,
  date,
}: {
  width: number
  date: Date
  magnification?: number
  start?: Date
  end?: Date
}) => {
  if (!start || !end) {
    return 0
  }

  const xScale = scaleTime().domain([start, end]).range([0, width]) // 절대좌표 기준으로 정확하게 계산 하게 range 추가

  return xScale(date) ?? 0
}

export function createTextDot(
  nodeList: Selection<BaseType, unknown, Element, unknown>,
  nodeWidth: number,
  textValue = "",
) {
  nodeList.each(function () {
    const text = select(this)
    const words = textValue.split(/\s+/) || text.text().split(/\s+/)

    const ellipsis = text.text("").append("tspan").attr("class", "elip").text("...")
    const width = parseFloat(
      (nodeWidth - 10 - (ellipsis?.node?.()?.getComputedTextLength() || 0)).toString(),
    )
    const numWords = words.join(" ")

    const tspan = text.insert("tspan", ":first-child").text(words.join(" "))

    let remainWords = words.slice().join(" ")

    while ((tspan.node()?.getComputedTextLength() || 0) > width && remainWords.length) {
      remainWords = remainWords.slice(0, -1)
      tspan.text(remainWords)
    }

    if (remainWords.length === numWords.length) {
      ellipsis.remove()
    }
  })
}

export const formatActivityBoxItems = (
  items: Activity[],
  dateStart: Date,
  dateFinish: Date,
  width: number,
) => {
  const ACTIVITY_MAX_STACK_HEIGHT = 3

  return getYIndexData(items, { maxStackHeight: ACTIVITY_MAX_STACK_HEIGHT, isStacked: false })
    .map((item) =>
      setTimelineBoxHeight(
        item,
        activityBoxHeight,
        activityBoxStartHeight + ACTIVITY_BOX_GUARANTEED_VISIBILITY_HEIGHT,
      ),
    )
    .map((item) => ({ ...item, id: item.idfActivity }))
    .map((item) => getActivityBoxProps({ data: item as Activity, dateStart, dateFinish, width }))
}

export const formatSessionBoxItems = (
  items: Session[],
  width: number,
  dateStart?: Date,
  dateFinish?: Date,
) => {
  const SESSION_MAX_STACK_HEIGHT = 9999999

  return getYIndexData(items, { maxStackHeight: SESSION_MAX_STACK_HEIGHT })
    .map((item) => ({ ...item, id: item.idfSession }))
    .map((item) => setTimelineBoxHeight(item, sessionBoxStartHeight, 5))
    .map((item) => getActivityBoxProps({ data: item as Session, dateStart, dateFinish, width }))
}

export const getActivityBoxProps = ({
  data,
  dateStart,
  dateFinish,
  width,
}: {
  data: ActivityDurationData | Activity | Session
  dateStart?: Date
  dateFinish?: Date
  width: number
  magnification?: number
}): ActivityDataProps & (ActivityDurationData | Partial<TimelineItemBoxProps>) => {
  const startX = getPositionX({
    start: dateStart,
    end: dateFinish,
    width,
    date: new Date(data.dateStart),
  })
  const boxWidth =
    getPositionX({
      start: dateStart,
      end: dateFinish,
      width,
      date: new Date(data.dateFinish),
    }) - startX

  const result = {
    ...data,
    startX,
    width: boxWidth,
  }

  if ((data as Activity).idfActivity) {
    ;(result as Partial<TimelineItemBoxProps>).id = (data as Activity).idfActivity as number
  }

  return result
}

export interface YIndexData extends Partial<Session>, Partial<Activity> {
  yIndex?: number
  overlapped?: boolean
  divideCount?: number
}

export function getYIndexData(
  data: Array<YIndexData>,
  { maxStackHeight = 0, isStacked = true }: { maxStackHeight?: number; isStacked?: boolean },
): YIndexData[] {
  const reversedStack: YIndexData[][] = [[]]

  data.forEach((item) => {
    let stackIdx = 0
    const copiedItem = { ...item }

    for (const layer of reversedStack) {
      const isMaxStackHeightReached = maxStackHeight > 0 && stackIdx === maxStackHeight - 1
      copiedItem.yIndex = isMaxStackHeightReached ? maxStackHeight - 1 : stackIdx

      if (layer.length === 0) {
        layer.push(copiedItem)
        break
      }

      const overlappedItems = layer.filter((layerItem) => {
        const copiedItemDateStart = moment(copiedItem.dateStart)
        const copiedItemDateFinish = moment(copiedItem.dateFinish)
        const layerItemDateStart = moment(layerItem.dateStart)
        const layerItemDateFinish = moment(layerItem.dateFinish)

        return (
          copiedItemDateStart.isBetween(layerItemDateStart, layerItemDateFinish, "second", "[]") ||
          copiedItemDateFinish.isBetween(layerItemDateStart, layerItemDateFinish, "second", "[]") ||
          layerItemDateStart.isBetween(copiedItemDateStart, copiedItemDateFinish, "second", "[]") ||
          layerItemDateFinish.isBetween(copiedItemDateStart, copiedItemDateFinish, "second", "[]")
        )
      })

      if (overlappedItems.length === 0) {
        layer.push(copiedItem)
        break
      }

      if (!isMaxStackHeightReached) {
        stackIdx++
        continue
      }

      if (isStacked) {
        const maxOverlappedItemsHeight = Math.max(
          ...overlappedItems.map((item) => item.yIndex || 0),
        )
        copiedItem.yIndex = Number((maxOverlappedItemsHeight + 0.1).toFixed(2))

        if (copiedItem.yIndex - maxStackHeight >= 0.3) {
          copiedItem.yIndex = maxStackHeight + 0.3
        }
      }

      layer.push(copiedItem)
    }

    if (
      maxStackHeight > 0 &&
      reversedStack.length < maxStackHeight &&
      reversedStack.at(-1)?.length
    ) {
      reversedStack.push([])
    }
  })

  return reversedStack.flat().map((item) => ({
    ...item,
    overlapped: item.yIndex !== undefined && item.yIndex > 0,
  }))
}

function setTimelineBoxHeight(
  item: YIndexData,
  boxHeight: number,
  startHeight: number,
  gap = activityIntervalDistance,
) {
  return {
    ...item,
    height: boxHeight,
    startY: startHeight + (item.yIndex || 0) * (boxHeight + gap),
  }
}
